var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"panel__content__element"},[_c('div',{staticClass:"g-handle"}),_c('accordion-element-component',_vm._b({staticClass:"g-grey-box",attrs:{"disabled":_vm.computedDisabled}},'accordion-element-component',{
      Data: {
        icon: [
          'custom',
          'sensors'
        ],
        title: 'Moisture',
        subTitle: _vm.computedMoistureStatusTitle
      }
    },false),[_c('moisture-component',{attrs:{"store":_vm.store,"moisture":_vm.moisture}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }